document.addEventListener("DOMContentLoaded", function () {

    const toggle = document.querySelector(".menu-toggle");
    const menu = document.querySelector(".menu");

    if (toggle && menu) {
        toggle.addEventListener("click", function () {
            menu.classList.toggle("active");
        });
    }

});

// ==============================================================

document.addEventListener("DOMContentLoaded", () => {

  const minus = document.querySelector(".qty-minus");
  const plus = document.querySelector(".qty-plus");
  const input = document.querySelector("#Quantity");

  if (minus && plus && input) {

    minus.addEventListener("click", () => {
      if (parseInt(input.value) > 1) {
        input.value = parseInt(input.value) - 1;
      }
    });

    plus.addEventListener("click", () => {
      input.value = parseInt(input.value) + 1;
    });

  }

});

// ==========================================

document.addEventListener("DOMContentLoaded", () => {

  const variantSelect = document.querySelector(".variant-select");
  const hiddenVariant = document.querySelector(".product-variant-id");

  if (variantSelect && hiddenVariant) {

    variantSelect.addEventListener("change", function () {

      hiddenVariant.value = this.value;

    });

  }

});